/* ==========================================================================
   HH DRIP SESSIONS — Story Viewer JavaScript
   Audio player, story panel navigation, gallery lightbox, auto-progress.
   ========================================================================== */

(function () {
  'use strict';

  /* ── Guard: only run on story pages ── */
  if (!document.querySelector('.hh-drip-story')) return;

  /* ──────────────────────────────────────────────
     HELPERS
     ────────────────────────────────────────────── */

  function formatTime(sec) {
    if (!sec || isNaN(sec)) return '0:00';
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ──────────────────────────────────────────────
     AUDIO PLAYER
     ────────────────────────────────────────────── */

  var audio        = $('#hh-drip-audio');
  var disc         = $('.hh-drip-vinyl__disc');
  var vinylPlay    = $('.hh-drip-vinyl__play');
  var msgBubble    = $('.hh-drip-message');
  var msgAudioBtn  = $('.hh-drip-message__audio-btn');
  var playbar      = $('.hh-drip-playbar');
  var playbarBtn   = $('.hh-drip-playbar__btn');
  var playbarFill  = $('.hh-drip-playbar__progress-fill');
  var playbarTime  = $('.hh-drip-playbar__time');
  var playbarProg  = $('.hh-drip-playbar__progress');
  var iconPlay     = $('.hh-drip-playbar__icon-play');
  var iconPause    = $('.hh-drip-playbar__icon-pause');

  /* ── Video mode ── */
  var ytIframe     = $('#hh-drip-yt-iframe');
  var videoTapBtn  = $('#hh-drip-video-tap');
  var startBtn     = $('#hh-drip-start-btn');
  var panel0       = $('.hh-drip-story__panel[data-panel="0"]');
  var hasVideo     = panel0 && panel0.getAttribute('data-has-video') === 'true';

  if (videoTapBtn) {
    videoTapBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var panelVideo = $('.hh-drip-panel-video');

      /* iOS Safari cannot autoplay YouTube iframes regardless of permissions.
         Detect iOS and open the video directly in the YouTube app instead. */
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS) {
        /* Open in YouTube app — plays immediately with no extra tap */
        var ytUrl = videoTapBtn.getAttribute('data-youtube-url');
        if (ytUrl) window.open(ytUrl, '_blank');
        return;
      }

      /* Desktop / Android: load iframe with autoplay */
      if (panelVideo) panelVideo.classList.add('is-playing');
      if (ytIframe) ytIframe.src = ytIframe.getAttribute('data-src');
    });
  }

  var isPlaying = false;
  var audioReady = false; /* iOS: track whether audio has been primed */

  /* ── Auto-Progress State ── */
  var autoProgressActive = false;
  var autoTimer          = null;
  var slideshowIndex     = -1;
  var slideshowRunning   = false;
  var PANEL0_DELAY       = 5000;   /* ms on vinyl before advancing */
  var SLIDE_DURATION     = 4000;   /* ms per photo */
  var GRID_FLASH_DELAY   = 1200;   /* ms grid visible before slideshow */

  /* Slideshow DOM refs */
  var slideshowEl      = $('.hh-drip-slideshow');
  var slides           = $$('.hh-drip-slideshow__slide');
  var slideshowCounter = $('.hh-drip-slideshow__current');

  /* Hide playbar only if no audio AND no video */
  if (!audio && !hasVideo && playbar) {
    playbar.classList.add('is-hidden');
  }

  function setPlayingState(playing) {
    isPlaying = playing;
    if (disc) disc.classList.toggle('is-playing', playing);
    if (vinylPlay) vinylPlay.classList.toggle('is-hidden', playing);
    if (iconPlay)  iconPlay.style.display  = playing ? 'none' : 'block';
    if (iconPause) iconPause.style.display = playing ? 'block' : 'none';
  }

  function togglePlay() {
    /* Video mode has its own tap handler — nothing to do here */
    if (hasVideo) return;

    if (!audio) return;
    if (audio.paused) {
      /* iOS Safari: prime audio on first user tap — call load() to
         ensure the browser fetches the source within the user gesture */
      if (!audioReady) {
        audio.load();
        audioReady = true;
      }
      audio.play().then(function () {
        setPlayingState(true);
        if (startBtn) startBtn.classList.add('is-hidden');
        /* Show message bubble after a short delay */
        if (msgBubble) {
          setTimeout(function () { msgBubble.classList.add('is-visible'); }, 800);
        }
        /* Start auto-progress if on Panel 0 and not already started */
        if (!autoProgressActive && currentIndex === 0) {
          startAutoProgress();
        }
      }).catch(function (err) {
        /* Log error for debugging; on iOS this catches autoplay/load failures */
        console.warn('Audio play failed:', err);
        setPlayingState(false);
      });
    } else {
      audio.pause();
      setPlayingState(false);
      /* Pause button stops auto-progress AND audio */
      if (autoProgressActive) {
        stopAutoProgress();
      }
    }
  }

  /* Bind play buttons */
  if (vinylPlay) vinylPlay.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
  if (playbarBtn) playbarBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
  if (msgAudioBtn) msgAudioBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });
  if (startBtn) startBtn.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); });

  /* Update progress */
  if (audio) {
    audio.addEventListener('timeupdate', function () {
      var pct = (audio.currentTime / audio.duration) * 100;
      if (playbarFill) playbarFill.style.width = pct + '%';
      if (playbarTime) {
        playbarTime.textContent = formatTime(audio.currentTime) + '  ' + formatTime(audio.duration);
      }
    });

    audio.addEventListener('ended', function () {
      setPlayingState(false);
      if (autoProgressActive) {
        stopAutoProgress();
      }
      closeSlideshow();
    });
  }

  /* Seek on progress bar click */
  if (playbarProg && audio) {
    playbarProg.addEventListener('click', function (e) {
      e.stopPropagation();
      var rect = playbarProg.getBoundingClientRect();
      var pct = (e.clientX - rect.left) / rect.width;
      audio.currentTime = pct * audio.duration;
    });
  }


  /* ──────────────────────────────────────────────
     AUTO-PROGRESS ENGINE
     ────────────────────────────────────────────── */

  function startAutoProgress() {
    autoProgressActive = true;
    slideshowIndex = -1;
    slideshowRunning = false;

    /* Animate progress bar for Panel 0 */
    animateBarFill(0, PANEL0_DELAY);

    /* After delay, advance to Panel 1 */
    autoTimer = setTimeout(function () {
      if (!autoProgressActive) return;
      completeBarFill(0);
      goToPanel(1);

      /* Brief grid flash, then open slideshow */
      autoTimer = setTimeout(function () {
        if (!autoProgressActive) return;
        openSlideshow();
      }, GRID_FLASH_DELAY);
    }, PANEL0_DELAY);
  }

  function stopAutoProgress() {
    autoProgressActive = false;
    slideshowRunning = false;
    clearTimeout(autoTimer);
    autoTimer = null;

    /* Stop any bar-fill animations */
    bars.forEach(function (bar) {
      bar.classList.remove('is-timing');
      var fill = bar.querySelector('.hh-drip-story__bar-fill');
      if (fill) {
        fill.style.transitionDuration = '';
        /* Freeze at current width */
      }
    });
  }

  function animateBarFill(barIndex, durationMs) {
    if (barIndex < 0 || barIndex >= bars.length) return;
    var bar = bars[barIndex];
    var fill = bar.querySelector('.hh-drip-story__bar-fill');
    if (!fill) return;

    /* Reset to 0 */
    fill.style.transitionDuration = '0s';
    fill.style.width = '0%';
    void fill.offsetWidth; /* force reflow */

    /* Animate to 100% */
    bar.classList.add('is-timing');
    fill.style.transitionDuration = durationMs + 'ms';
    fill.style.width = '100%';
  }

  function completeBarFill(barIndex) {
    if (barIndex < 0 || barIndex >= bars.length) return;
    var bar = bars[barIndex];
    var fill = bar.querySelector('.hh-drip-story__bar-fill');
    if (!fill) return;
    bar.classList.remove('is-timing');
    fill.style.transitionDuration = '0.3s';
    fill.style.width = '100%';
  }


  /* ──────────────────────────────────────────────
     SLIDESHOW (fullscreen photo cycling in Panel 1)
     ────────────────────────────────────────────── */

  function openSlideshow() {
    if (!slideshowEl || slides.length === 0) {
      /* No photos: skip straight to panel 2 */
      if (autoProgressActive) {
        completeBarFill(1);
        goToPanel(2);
        completeBarFill(2);
        autoProgressActive = false;
      }
      return;
    }

    slideshowRunning = true;
    slideshowIndex = 0;
    slideshowEl.classList.add('is-active');
    slideshowEl.setAttribute('aria-hidden', 'false');

    /* Activate first slide */
    showSlide(0);

    /* Animate bar fill for total slideshow duration */
    var totalDuration = slides.length * SLIDE_DURATION;
    animateBarFill(1, totalDuration);

    /* Start cycling */
    scheduleNextSlide();
  }

  function showSlide(index) {
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    slideshowIndex = index;
    if (slideshowCounter) {
      slideshowCounter.textContent = (index + 1);
    }
  }

  function scheduleNextSlide() {
    if (!autoProgressActive || !slideshowRunning) return;

    autoTimer = setTimeout(function () {
      if (!autoProgressActive || !slideshowRunning) return;

      var nextIndex = slideshowIndex + 1;
      if (nextIndex >= slides.length) {
        /* Last photo done → advance to Panel 2 */
        closeSlideshow();
        completeBarFill(1);
        goToPanel(2);
        completeBarFill(2);
        autoProgressActive = false;
        slideshowRunning = false;
      } else {
        showSlide(nextIndex);
        scheduleNextSlide();
      }
    }, SLIDE_DURATION);
  }

  function closeSlideshow() {
    if (slideshowEl) {
      slideshowEl.classList.remove('is-active');
      slideshowEl.setAttribute('aria-hidden', 'true');
    }
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    slideshowIndex = -1;
    slideshowRunning = false;
  }

  /* Tap on slideshow: stop auto-progress, keep audio */
  if (slideshowEl) {
    slideshowEl.addEventListener('click', function (e) {
      e.stopPropagation();

      if (autoProgressActive) {
        stopAutoProgress();
        /* Keep slideshow visible but frozen on current photo */
        slideshowRunning = false;
        return;
      }

      /* If already stopped: tap advances to next or closes */
      if (slideshowIndex >= 0 && slideshowIndex < slides.length - 1) {
        showSlide(slideshowIndex + 1);
      } else {
        closeSlideshow();
      }
    });
  }


  /* ──────────────────────────────────────────────
     STORY NAVIGATION
     ────────────────────────────────────────────── */

  var panels = $$('.hh-drip-story__panel');
  var bars   = $$('.hh-drip-story__bar');
  var currentIndex = 0;

  function goToPanel(index) {
    if (index < 0 || index >= panels.length) return;

    /* If leaving Panel 0 in video mode, stop the iframe */
    if (currentIndex === 0 && index !== 0 && hasVideo) {
      if (ytIframe) ytIframe.src = '';
      var panelVideo = $('.hh-drip-panel-video');
      if (panelVideo) panelVideo.classList.remove('is-playing');
    }

    /* If leaving Panel 1, close slideshow */
    if (currentIndex === 1 && index !== 1) {
      closeSlideshow();
    }

    /* Deactivate all panels */
    panels.forEach(function (p) {
      p.classList.remove('is-active');
      p.style.display = ''; /* clear any legacy inline styles */
    });

    /* Activate target */
    panels[index].classList.add('is-active');

    /* Update progress bars */
    bars.forEach(function (bar, i) {
      bar.classList.remove('is-active', 'is-complete');
      if (i < index) {
        bar.classList.add('is-complete');
        var fill = bar.querySelector('.hh-drip-story__bar-fill');
        if (fill) {
          fill.style.transitionDuration = '0.3s';
          fill.style.width = '100%';
        }
      }
      if (i === index) bar.classList.add('is-active');
    });

    currentIndex = index;
  }

  /* Tap navigation on the phone container */
  var phone = $('.hh-drip-story__phone');
  if (phone) {
    phone.addEventListener('click', function (e) {
      /* Skip if clicking on interactive elements */
      if (e.target.closest(
        '.hh-drip-vinyl__play, .hh-drip-playbar, .hh-drip-gallery__item, ' +
        '.hh-drip-lightbox, .hh-drip-spotify__iframe, .hh-drip-message__audio-btn, ' +
        '.hh-drip-slideshow, button, a, iframe'
      )) return;

      /* Manual navigation kills auto-progress, audio continues */
      if (autoProgressActive) {
        stopAutoProgress();
        closeSlideshow();
      }

      var rect = phone.getBoundingClientRect();
      var x = e.clientX - rect.left;

      if (x < rect.width * 0.3) {
        goToPanel(currentIndex - 1);
      } else {
        goToPanel(currentIndex + 1);
      }
    });
  }

  /* Desktop nav arrows */
  var prevBtn = $('.hh-drip-story__nav--prev');
  var nextBtn = $('.hh-drip-story__nav--next');
  if (prevBtn) prevBtn.addEventListener('click', function () {
    if (autoProgressActive) { stopAutoProgress(); closeSlideshow(); }
    goToPanel(currentIndex - 1);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    if (autoProgressActive) { stopAutoProgress(); closeSlideshow(); }
    goToPanel(currentIndex + 1);
  });

  /* Keyboard navigation */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      if (autoProgressActive) { stopAutoProgress(); closeSlideshow(); }
      goToPanel(currentIndex + 1);
    }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      if (autoProgressActive) { stopAutoProgress(); closeSlideshow(); }
      goToPanel(currentIndex - 1);
    }
    if (e.key === ' ') { e.preventDefault(); togglePlay(); }
  });

  /* Initialize first panel */
  goToPanel(0);


  /* ──────────────────────────────────────────────
     GALLERY LIGHTBOX
     ────────────────────────────────────────────── */

  var lightbox    = $('.hh-drip-lightbox');
  var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
  var closeBtn    = $('.hh-drip-lightbox__close');

  $$('.hh-drip-gallery__item').forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.stopPropagation();

      /* Manual gallery interaction stops auto-progress, audio continues */
      if (autoProgressActive) {
        stopAutoProgress();
        closeSlideshow();
      }

      var img = item.querySelector('img');
      if (!img || !lightbox || !lightboxImg) return;

      /* Use a larger version for the lightbox */
      var src = img.src;
      src = src.replace(/width=\d+/, 'width=1200');
      lightboxImg.src = src;
      lightbox.classList.add('is-open');
    });
  });

  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('is-open');
  }

  if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });

  /* Tap anywhere in lightbox to close */
  if (lightbox) lightbox.addEventListener('click', function (e) {
    closeLightbox();
  });

  /* Tap on the image itself to close */
  if (lightboxImg) lightboxImg.addEventListener('click', function (e) {
    e.stopPropagation();
    closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });


  /* ──────────────────────────────────────────────
     SHARE BUTTON — copy page link + toast
     ────────────────────────────────────────────── */

  var shareBtn = document.getElementById('hh-drip-share');
  var toast    = document.getElementById('hh-drip-toast');
  var toastTimer = null;

  function showToast(msg) {
    if (!toast) return;
    if (msg) toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var url = window.location.href.split('?')[0]; /* clean URL without query params */
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast('Link copied!');
        }).catch(function () {
          showToast('Link copied!');
        });
      } else {
        /* Fallback for older browsers */
        var tmp = document.createElement('textarea');
        tmp.value = url;
        tmp.style.position = 'fixed';
        tmp.style.opacity = '0';
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
        showToast('Link copied!');
      }
    });
  }

})();
